/* ============
 * Bill Status Transformer
 * ============
 *
 * The transformer for the creditNoteReasons.
 */

import Transformer from './transformer';

export default class creditNoteReasonTransformer extends Transformer {

  static fetch(creditNoteReasons) {
    return {
      creditNoteReasonId: creditNoteReasons.id,
      creditNoteReasonType: creditNoteReasons.type,
      creditNoteReasonAttributes: creditNoteReasons.attributes,
      creditNoteReasonExclusiveToPlans: creditNoteReasons.exclusive_to_plans,
      creditNoteReasonDescription: creditNoteReasons.description,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/creditNoteReason.js